<template>
    <el-icon @click="toggleClick" class="hamburger" :class="{'is-active':UserStore.isCollapse}">
     <Fold /></el-icon>
</template>

<script setup>
import { UserInfoStore, themeStore } from "@/stores/index.js";
const UserStore = UserInfoStore();
	const emit=defineEmits(['handleClick'])
  defineOptions({
    name:'Hamburger'
  })
	import{reactive,toRefs} from "vue"
	const state=reactive({
	})
	const toggleClick=()=>{
		 emit('handleClick')
	}
</script>
<style scoped lang='scss'>
.hamburger {
  display: inline-block;
  cursor: pointer;
  width: 16px;
  height: 16px;
  // transform: rotate(90deg);
  transition: .4s;
  transform-origin: 50% 50%;
}

.hamburger.is-active {
  transform: rotate(-180deg);
}
</style>
